import { IconInfoSolid, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const HideNotice = () => {
  return (
    <Container>
      <Text variant='Body_18_SemiBold' color='textStrong' css={Title}>
        실측 사이즈
      </Text>
      <Text variant='Body_14_Medium' color='textQuaternary' css={Description}>
        <IconInfoSolid width={16} height={16} color='iconQuaternary' />
        수정 요청이 완료되어 숨김 처리되었어요
      </Text>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px 16px 240px 16px;
  background-color: ${vars.color.staticWhite};
`;

const Description = css`
  padding-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
`;

const Title = css`
  margin: 0 0 16px 0;
`;
